import React from 'react'
import { type Unit } from '../../../../store/slices/unitsSlice'
import Icon from '../../../../app/icon/Icon'

interface IProps {
    units: Unit[]
    selectedCategory: string | string[]
    onChange: (value: number) => void;
}

export default function ScheduleAdminUnitsList({
    units,
    selectedCategory,
    onChange
}: IProps): JSX.Element {
    const defaultImage = '/assets/media/istockphoto.jpg'
    return (
        <div className="container my-2" >
            <div className="row">
                {units && units.length > 0 && units.map((unit, i) => (
                    <div key={`unit-${i}`} className={`col-6  mb-4 `}
                        onClick={() => {
                            onChange(unit?.id);
                        }}
                    >
                        <div className={`schedule-filters-unit-card ${Number(selectedCategory) === unit.id ? 'is-selected' : ''}`}>
                            <img
                                className="schedule-filters-unit-card__image"
                                src={unit?.attributes?.Images?.[0] ? unit.attributes.Images[0] : defaultImage}
                                alt="img_unit"
                            />

                            <div className="schedule-filters-unit-card__overlay">
                                <span className="schedule-filters-unit-card__headline text-white">
                                    {unit?.attributes?.Marketing?.Headline}
                                </span>

                                <div className="schedule-filters-unit-card__meta text-white">
                                    <span className="schedule-filters-unit-card__price">
                                        AED {unit?.attributes?.Marketing?.Price}
                                    </span>
                                    <span className="schedule-filters-unit-card__location">
                                        <Icon name="location_on" filled className="fs-8 text-white" />
                                        {unit?.attributes?.Property?.data?.attributes?.Area}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

